function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Share(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.613 1a4.283 4.283 0 014.277 4.278 4.283 4.283 0 01-4.277 4.278 4.271 4.271 0 01-3.346-1.616l-5.808 3.083a4.28 4.28 0 010 1.809l5.865 3.113a4.273 4.273 0 013.37-1.646 4.282 4.282 0 014.278 4.277 4.283 4.283 0 01-4.277 4.279 4.283 4.283 0 01-4.202-5.088l-5.905-3.133a4.271 4.271 0 01-3.31 1.571A4.283 4.283 0 011 11.927 4.283 4.283 0 015.278 7.65c1.333 0 2.525.613 3.31 1.572l5.832-3.095A4.282 4.282 0 0118.613 1zm.082 15.299a2.28 2.28 0 00-2.278 2.277 2.282 2.282 0 002.278 2.279 2.279 2.279 0 000-4.556zM5.278 9.649A2.28 2.28 0 003 11.927a2.28 2.28 0 002.277 2.278 2.28 2.28 0 002.278-2.278A2.28 2.28 0 005.278 9.65zM18.613 3a2.28 2.28 0 00-2.277 2.278 2.28 2.28 0 002.277 2.278 2.28 2.28 0 002.277-2.278A2.28 2.28 0 0018.613 3z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
const MemoShare = /*#__PURE__*/React.memo(Share);
export default MemoShare;